// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 255) return "static/chunks/255-cc5ac67e9d8411c2.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"bc1b9984a7760aab","298":"3c17f9a45cf5b456","340":"0a966496ce4a8dc8","367":"16318e14b159a507","639":"662b2e7c337118a6","748":"66c7d39cc80105f7"}[chunkId] + ".js";
};